export const SliderLimits = {
  MAX: 1000000,
  MIN: 100000,
  STEP: 10000
};

export const UsdConversionRate = 285;

export const CompareWidgetLimit = 3;

export const DefaultCoverageLimit = 1000000;
